import type { PageProps } from "@components/Pages/models/Pages";
import { ContentLanguage } from "@ext/localization/core/model/Language";

// Every page template said `lang="ru"` before the language was read from the catalog:
// a catalog that declares no language keeps it.
const DEFAULT_HTML_LANG = ContentLanguage.ru;

// `language` comes from user-authored .doc-root.yaml and is typed, not validated,
// so anything unknown falls back instead of landing inside the lang attribute.
export const resolveHtmlLang = (language?: string): string =>
	language && (Object.values(ContentLanguage) as string[]).includes(language) ? language : DEFAULT_HTML_LANG;

/**
 * The language of the page's content: the one its address names when the catalog declares it, else the catalog's own.
 * The address names a language whenever a folder is spelled like one (`it/` of an IT department), declared or not.
 */
const getPageLanguage = (data: PageProps): string => {
	if (data.page !== "article" || data.data.catalogProps.notFound) return DEFAULT_HTML_LANG;
	const { language, supportedLanguages } = data.data.catalogProps;
	const named = data.context.language.content;
	return resolveHtmlLang(named && supportedLanguages.includes(named) ? named : language);
};

export default getPageLanguage;
